import React, { useState } from 'react'
import { Typography, Menu, MenuItem, TextField, Grid, IconButton, Tooltip } from '@material-ui/core'
import { getLabelStatusCadeiaDeCustodia } from 'helpers/labels'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { BaseCard, CardField } from 'components'
import useStyles from './styles'
import { Autocomplete } from '@material-ui/lab'
import { useCestaOperacaoLote } from 'hooks/useCestaOperacaoLote'

export const CardVestigio = (props) => {
  const classes = useStyles()
  moment.locale('pt-br', localization)
  const { vestigio, handleClick, formDNA, comPrioridade, prioridade, justificativa, materialBiologico, tipoAmostra, handleChangeProVestigio } = props
  const { addVestigio, verificarItemEmCesta } = useCestaOperacaoLote()

  const [anchorElCesta, setAnchorElCesta] = useState(null)

  const labelPrioridade = (valor) => {
    if (valor === 1) return '1°'
    if (valor === 2) return '2°'
    if (valor === 3) return '3°'
    if (valor === 4) return '4°'
    return ''
  }

  const getLabelMaterialBiologico = (valor) => {
    if (valor === 'M1') return 'Mucosa Oral'
    if (valor === 'M2') return 'Sangue'
    if (valor === 'M3') return 'Material de toque'
    if (valor === 'M4') return 'Pelo'
    if (valor === 'M5') return 'Sêmen'
    if (valor === 'M6') return 'Células descamativas epiteliais em vestes'
    if (valor === 'M7') return 'Osso'
    if (valor === 'M8') return 'Dentes'
    if (valor === 'M9') return 'M9 - Especificar'
    return ''
  }

  const getLabelTipoAmostra = (valor) => {
    if (valor === 'QUESTIONADA') return 'Questionada'
    if (valor === 'REFERENCIA') return 'Referência'
    if (valor === 'EXCLUSAO') return 'Exclusão'
    return ''
  }

  const getNaturezaUnificada = () => {
    const gen = vestigio.tiposGens?.map((t) => t.nome).join(', ')
    const esp = vestigio.tiposEsps?.map((t) => t.nome).join(', ')
    if (!gen && !esp) return '-'
    if (!gen) return esp
    if (!esp) return gen
    return `${gen} / ${esp}`
  }

  const getStatusCompleto = () => {
    let status = getLabelStatusCadeiaDeCustodia(vestigio.statusCadeiaCustodia)
    if (vestigio.statusCadeiaCustodia === 'GUARDADO' && vestigio.setAtual) {
      status += ` - ${vestigio.setAtual.nome} (${vestigio.setAtual.sigla})`
    }
    return status
  }

  const handleClickBotaoAcoes = (event) => {
    event.stopPropagation()
    setAnchorElCesta(event.currentTarget)
  }

  const handleCloseMenuDocumento = () => {
    setAnchorElCesta(null)
  }

  const natureza = vestigio ? getNaturezaUnificada() : '-'
  const statusCompleto = vestigio ? getStatusCompleto() : '-'

  return (
    vestigio ? (
      <div>
        <BaseCard
          avatar="VESTIGIO"
          title={vestigio.contraprova ? 'Vestígio - Contraprova' : 'Vestígio'}
          onClick={() => handleClick(vestigio.id)}
          onNovaAba={() => handleClick(vestigio.id, true)}
          action={
            <IconButton aria-label="settings" onClick={handleClickBotaoAcoes}>
              <MoreVertIcon />
            </IconButton>
          }
        >
          <CardField label="Identificador" value={vestigio.identificador} />
          <CardField label="Lacre" value={vestigio.lacre} />
          <CardField
            label="Status"
            value={
              statusCompleto !== '-' ? (
                <Tooltip title={statusCompleto} arrow>
                  <span>{statusCompleto}</span>
                </Tooltip>
              ) : (
                '-'
              )
            }
            valueClassName={classes.singleLineValue}
          />
          <CardField
            label="Natureza"
            value={
              natureza !== '-' ? (
                <Tooltip title={natureza} arrow>
                  <span>{natureza}</span>
                </Tooltip>
              ) : (
                '-'
              )
            }
            valueClassName={classes.singleLineValue}
          />

          {vestigio.contraprova && (
            <CardField
              label="Exame origem"
              value={vestigio.exOrig ? vestigio.exOrig.numeroExame : 'não identificado'}
            />
          )}

          <CardField label="Data de entrada" value={moment(vestigio.createdAt).format('DD/MM/YYYY')} />
          <CardField
            label="Descrição"
            value={
              vestigio.descricao && vestigio.descricao.length > 80
                ? `${vestigio.descricao.slice(0, 80)}...`
                : vestigio.descricao
            }
          />

          {formDNA && (
            <Grid container justifyContent="space-between" spacing={1} className={classes.dnaFormContainer}>
              <Grid item sm={12} xs={12} md={12} style={{ marginBottom: '5px' }}>
                <Typography style={{ fontSize: '0.75rem', letterSpacing: '0.2px', fontWeight: 600 }}>
                  Dados para o exame de DNA
                </Typography>
              </Grid>
              <Grid item sm={12} xs={12} md={12}>
                <Autocomplete
                  name="tipoMaterialBiologico"
                  value={materialBiologico}
                  defaultValue={materialBiologico}
                  noOptionsText="Sem informações"
                  options={['M1', 'M2', 'M3', 'M4', 'M5', 'M6', 'M7', 'M8', 'M9']}
                  onChange={(event, newValue) => handleChangeProVestigio(vestigio.id, 'tipoMaterialBiologico', newValue)}
                  required
                  getOptionLabel={(option) => getLabelMaterialBiologico(option)}
                  renderOption={(option) => getLabelMaterialBiologico(option)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      variant="outlined"
                      label="TIPO DE MATERIAL BIOLÓGICO"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item sm={12} xs={12} md={12}>
                <Autocomplete
                  name="tipoAmostra"
                  value={tipoAmostra}
                  noOptionsText="Sem informações"
                  options={['QUESTIONADA', 'REFERENCIA', 'EXCLUSAO']}
                  onChange={(event, newValue) => handleChangeProVestigio(vestigio.id, 'tipoAmostra', newValue)}
                  required
                  getOptionLabel={(option) => getLabelTipoAmostra(option)}
                  renderOption={(option) => getLabelTipoAmostra(option)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      variant="outlined"
                      label="TIPO DE AMOSTRA"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              </Grid>

              {comPrioridade && (
                <>
                  <Grid item sm={12} xs={12} md={12}>
                    <Autocomplete
                      name="prioridade"
                      value={prioridade}
                      noOptionsText="Sem informações"
                      options={[1, 2, 3, 4]}
                      onChange={(event, newValue) => handleChangeProVestigio(vestigio.id, 'prioridade', newValue)}
                      required
                      getOptionLabel={(option) => `${labelPrioridade(option)}`}
                      renderOption={(option) => `${labelPrioridade(option)}`}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          variant="outlined"
                          label="PRIORIDADE"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item sm={12} xs={12} md={12}>
                    <TextField
                      fullWidth
                      label="JUSTIFICATIVA"
                      variant="outlined"
                      required
                      name="justificativa"
                      onChange={(event) => handleChangeProVestigio(vestigio.id, 'justificativa', event.target.value)}
                      value={justificativa}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          )}
        </BaseCard>

        <Menu id="menu-acoes-vestigio" anchorEl={anchorElCesta} open={Boolean(anchorElCesta)} onClose={handleCloseMenuDocumento} keepMounted>
          <MenuItem
            onClick={() => {
              addVestigio(vestigio)
              handleCloseMenuDocumento()
            }}
            disabled={verificarItemEmCesta(vestigio.id)}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img
                src="/images/cesta-add-black.png"
                alt="Adicionar à cesta"
                className="img-icon-invert-dark"
                style={{
                  width: 20,
                  height: 20,
                  opacity: verificarItemEmCesta(vestigio.id) ? 0.5 : 1,
                }}
              />
              <Typography variant="body2" style={{ marginLeft: '8px' }}>
                Adicionar à cesta
              </Typography>
            </div>
          </MenuItem>
        </Menu>
      </div>
    ) : null
  )
}
